// const API_BASE = 'https://bikurimapp.herokuapp.com/api';
export const API_BASE = 'http://bikurimapp.it-hive.net:3001';
